module.exports = __webpack_public_path__ + "img/icon - Rocket ship.4b18aa69.png";